<div dragula="CLICKS" [dragulaModel]="list" (dragulaModelChange)="list = $event" id="left">
  <div *ngIf="getLoadingPenalties$ | async" class="loading-sppiner">
    {{ 'loadingpenalty.text_1' | translate }}
    <div class="loader"></div>
  </div>
  <div *ngIf="!(getLoadingPenalties$ | async)">
    <div
      class="response-empty"
      *ngIf="
        penaltyFareBasisMachineLearning &&
        penaltyFareBasisMachineLearning.farebasisList &&
        penaltyFareBasisMachineLearning.farebasisList.length == 0
      "
    >
      {{ 'loadingpenalty.text_2' | translate }}
    </div>

    <div *ngIf="penaltyFareBasisMachineLearning">
      <div *ngFor="let item of penaltyFareBasisMachineLearning.farebasisList; let i = index">
        <app-accordion
          theme="penalty"
          [contentOverflow]="true"
          size="3em"
          [arrowRight]="false"
          [fullColumn]="true"
          maxHeight="45vh"
          [needDynamicClass]="true"
          [passengerType]="passengerTypeFareBasis"
          [passengersListByFareBasis]="item.passengerTypes"
        >
          <div class="drag-cursor tab-title" title>
            <div class="columns is-vcentered">
              <div class="column is-1 pl-4"></div>
              <div class="column is-1 pl-0">
                <em class="mdi mdi-drag mdi-18px" aria-hidden="true"></em>
              </div>
              <div class="column pl-0">{{ item.fareBasis }}</div>
            </div>
          </div>
          <div class="p-3" content>
            <div *ngFor="let freeText of item?.freeText" class="mb-3">
              <div class="weight-medium">
                {{ 'exception-mode.category' | translate | uppercase }}
                {{ freeText.category }}
              </div>
              <div [innerHTML]="highlight(item, freeText.text)"></div>
            </div>
            <div *ngFor="let model of item?.modelRespond" class="p-1">
              <div class="weight-medium">question {{ formatQuestion(model.question) }}</div>
              <div [innerHTML]="formatAnswer(model.answer)"></div>
            </div>
          </div>
        </app-accordion>
      </div>
    </div>
  </div>
</div>
